// extracted by mini-css-extract-plugin
export var body = "_m0-8";
export var button = "_m0-0";
export var closeButton = "_m0-5";
export var content = "_m0-3";
export var empty = "_m0-f";
export var grid = "_m0-c";
export var header = "_m0-4";
export var icon = "_m0-1";
export var option = "_m0-d";
export var optionSelected = "_m0-e";
export var overlay = "_m0-2";
export var searchIcon = "_m0-a";
export var searchInput = "_m0-b";
export var searchWrapper = "_m0-9";
export var title = "_m0-6";
export var visuallyHidden = "_m0-7";